import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import config from '@/config';
import { DownloadButton } from '@/components/DownloadButton';
import Dropdown from '@/components/Dropdown';

export const FinancingAgreements = ({ fundraisingId, data }) => {
  const { t } = useTranslation('loans');
  if (!data) return null;

  return (
    <div className={classnames('loan-info-contracts', data?.insurance_strategy)}>
      <Dropdown
        label={
          <div className="loan-info-contracts__header">
            <h2 className="f-22 f-500">{t('fin_agreements.header')}</h2>
            {/*<RoundLink*/}
            {/*  label={t('fin_agreements.download_all')}*/}
            {/*  path={`${config.apiURL}fundraisings/${data?.id}/agreements/`}*/}
            {/*  className="loan-info-contracts__download"*/}
            {/*  fillBackground*/}
            {/*  isExternal*/}
            {/*/>*/}
          </div>
        }
      >
        {fundraisingId === 92 ? (
          <div className="loan-info__empty-message f-16">
            {t('fin_agreements.processing_message')}
          </div>
        ) : data ? (
          <div className="loan-info-contracts__table">
            <div className="loan-info-contracts__thead">
              <div className="loan-info-contracts__thead-col">{t('fin_agreements.loan_type')}</div>
              <div className="loan-info-contracts__thead-col">
                {t('fin_agreements.loan_number')}
              </div>
              {/*<div className="loan-info-contracts__thead-col">{t('fin_agreements.financing_agreement')}</div>*/}
              {/*<div className="loan-info-contracts__thead-col">{t('fin_agreements.surety_agreement')}</div>*/}
              <div className="loan-info-contracts__thead-col">
                {t('fin_agreements.download_agreements')}
              </div>
            </div>
            <div className="loan-info-contracts__tbody">
              {data.agreements.map(agreement => (
                <div className="loan-info-contracts__tbody-row" key={agreement.id}>
                  <div className="loan-info-contracts__tbody-col">{agreement.risk_group_title}</div>
                  <div className="loan-info-contracts__tbody-col">
                    {t('fin_agreements.loan_number_prefix', { id: agreement.id })}
                  </div>
                  {/*<div className="loan-info-contracts__tbody-col">*/}
                  {/*  <MyLink*/}
                  {/*    href={`${config.apiURL}loans/${agreement.id}/agreement/`}*/}
                  {/*    isExternal*/}
                  {/*  >*/}
                  {/*    {t('fin_agreements.download')}*/}
                  {/*  </MyLink>*/}
                  {/*</div>*/}
                  {/*<div className="loan-info-contracts__tbody-col">*/}
                  {/*  <MyLink*/}
                  {/*    href={`${config.apiURL}loans/${agreement.id}/surety_agreement/`}*/}
                  {/*    isExternal*/}
                  {/*  >*/}
                  {/*    {t('fin_agreements.download')}*/}
                  {/*  </MyLink>*/}
                  {/*</div>*/}
                  <div className="loan-info-contracts__tbody-col">
                    <DownloadButton
                      filename={`loan-assignments-${agreement.id}`}
                      link={`${config.apiURL}/founders/loans/${agreement.id}/assignments/`}
                    >
                      {t('fin_agreements.download')}
                    </DownloadButton>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="loan-info__empty-message f-16">{t('fin_agreements.no_agreements')}</div>
        )}
      </Dropdown>
    </div>
  );
};
